import { PageContainer } from 'modules/experiments/components/pages/CommonStyled';
import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import { colors, H4, spacing } from 'ui/theme';
import { FlexSpacer } from 'ui/flexSpacer';
import { Takeover } from 'ui/workflows/takeover';

import { CriteriaRetentionBody } from './CriteriaRetentionBody';
import { useCriteriaRetentionContext } from './CriteriaRetentionContext';
import { LastModified } from './LastModified';
import { CONTENT, TAKEOVER_SIZE } from './constants';

const HeaderBarTitle = styled(H4)`
    color: ${colors.white};
`;

export const CriteriaRetentionTakeover = () => {
  const { isOpen, setIsOpen, isLoadingSettings, hasCriteriaSettingsError, handleSave } =
    useCriteriaRetentionContext();

  const handleOnSave = () => {
    handleSave();
  };

  if (!isOpen) return null;
  return (
    <PageContainer>
      <Takeover
        isOverlay
        isMainApp
        noPadding
        withPortal
        size={TAKEOVER_SIZE}
        onClose={() => setIsOpen(false)}
        HeaderBarContent={<HeaderBarTitle>{CONTENT.takeover.title}</HeaderBarTitle>}
        Body={<CriteriaRetentionBody />}
        Footer={
          <FlexSpacer
            padding={`0 ${spacing.half}`}
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <LastModified />
            <FlexSpacer justifyContent="flex-start" gap={spacing.half} flexDirection="row">
              <SecondaryButton onClick={() => setIsOpen(false)}>
                {CONTENT.takeover.cancelButton}
              </SecondaryButton>
              <PrimaryButton
                onClick={handleOnSave}
                isLoading={isLoadingSettings}
                isDisabled={hasCriteriaSettingsError}
              >
                {CONTENT.takeover.saveButton}
              </PrimaryButton>
            </FlexSpacer>
          </FlexSpacer>
        }
        alignFooterRight
      />
    </PageContainer>
  );
};
